import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const AlignLeftIcon = forwardRef<SVGSVGElement, IconProps>(function AlignLeftIcon(
  { color = '', height = 12, width = 12, ...props },
  ref,
) {
  return (
    <svg ref={ref} width={width} height={height} viewBox="0 0 12 12" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 2.7127C2 2.31909 2.25584 2 2.57143 2H9.42857C9.74416 2 10 2.31909 10 2.7127C10 3.10632 9.74416 3.42541 9.42857 3.42541H2.57143C2.25584 3.42541 2 3.10632 2 2.7127ZM2 6C2 5.60639 2.25584 5.2873 2.57143 5.2873H4.85714C5.17273 5.2873 5.42857 5.60639 5.42857 6C5.42857 6.39362 5.17273 6.7127 4.85714 6.7127H2.57143C2.25584 6.7127 2 6.39362 2 6ZM2 9.2873C2 8.89368 2.25584 8.57459 2.57143 8.57459H7.14286C7.45845 8.57459 7.71429 8.89368 7.71429 9.2873C7.71429 9.68091 7.45845 10 7.14286 10H2.57143C2.25584 10 2 9.68091 2 9.2873Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
